export const specsort = [
    {
        id: '',
        name: 'Obgyn',
        slug: 'obgyn',
        value: 100
    }
];